/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const electra_protocol_chain_about = () => `Electra Protocol is an ecosystem for near real-time transactions at almost no cost. Upcoming features include multicurrency payments and smart contracts that will empower anyone to create their own solutions. Simply put: Instant payments without needing a bank account.`
